import { Role } from '@curbnturf/entities';

/** How each role reads in the admin; the raw values ("salesmanager") are for the server. */
export const ROLE_LABELS: Record<Role, string> = {
  [Role.guest]: 'Guest',
  [Role.host]: 'Host',
  [Role.boondocker]: 'Boondocker (retired)',
  [Role.admin]: 'Admin',
  [Role.affiliate]: 'Affiliate',
  [Role.sales]: 'Sales',
  [Role.salesManager]: 'Sales manager',
  [Role.report]: 'Reports only',
};

/** Roles that open staff tools: changing to or from one is confirmed. */
export const STAFF_ROLES: readonly Role[] = [Role.admin, Role.sales, Role.salesManager, Role.report];
